import { useEffect, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { blogActions, blogSelectors } from "../../../ducks/blog";
import { AppDispatch, StoreState } from "../../../store";
import { appSelectors } from '../../../ducks/app';

export const useBlogPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [page, setPage] = useState(1);
  const pageSize = 10; // Updated to match API response

  const blogs = useSelector((state: StoreState) => ({
    data: blogSelectors.data(state),
    total_items: blogSelectors.totalItems(state),
    total_pages: blogSelectors.totalPages(state),
    current_page: blogSelectors.currentPage(state),
    page_size: blogSelectors.pageSize(state),
    next_page: blogSelectors.nextPage(state),
    previous_page: blogSelectors.previousPage(state),
  }));

  const isLoading = useSelector((state: StoreState) => appSelectors.isLoading(state));

  useEffect(() => {
    // Pass page and page_size as query parameters
    dispatch(blogActions.getBlogs.started({
      page,
      page_size: pageSize,
    }));
  }, [dispatch, page, pageSize]);

  const onSetPage = useCallback((newPage: number) => {
    setPage(newPage);
  }, []);

  const onPrevious = useCallback(() => {
    setPage((prev) => Math.max(1, prev - 1));
  }, []);

  const onNext = useCallback(() => {
    if (blogs.total_pages && page < blogs.total_pages) {
      setPage((prev) => prev + 1);
    }
  }, [blogs.total_pages, page]);

  // Check if pagination should be shown
  const hasPagination = blogs.total_pages && blogs.total_pages > 1;

  return {
    blogs,
    isLoading,
    page,
    onSetPage,
    onPrevious,
    onNext,
    hasPagination,
  };
};
